import { useEffect, useState } from "react";

import { cn } from "../../components/ui/cn";

/**
 * A transient "Saved" flash.
 *
 * Everything on this page saves as soon as you click away rather than behind a
 * Save button, which is only reassuring if the page says so -- otherwise the
 * honest reading of a field that just sits there is that nothing happened.
 */
export function SavedFlash({ pending, at }: { pending: boolean; at: number | null }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!at) return;
    setVisible(true);
    const timer = setTimeout(() => setVisible(false), 1600);
    return () => clearTimeout(timer);
  }, [at]);

  if (pending) return <span className="text-[11px] text-faint">Saving…</span>;
  if (!visible) return null;
  return <span className="text-[11px] text-sla-ok">Saved</span>;
}

export const inputClass = cn(
  "rounded-md border border-line bg-surface px-2.5 py-1.5 text-sm text-content",
  "focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-500/40",
);

/**
 * Mid-tone hues, matching the seeded pipelines.
 *
 * Deliberately not the pale avatar tints: a pipeline colour is a 6px dot, and
 * a pastel one beside another pastel one is two grey dots at that size.
 */
export const PIPELINE_COLORS: string[] = [
  "#d8227a",
  "#7c3aed",
  "#2563eb",
  "#0891b2",
  "#059669",
  "#65a30d",
  "#d97706",
  "#dc2626",
  "#475569",
];

/** "Internal Sales" -> "internal-sales", matching the server's slug rule. */
export function slugify(value: string): string {
  return value
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 64);
}

export function describeMinutes(minutes: number): string {
  if (minutes < 60) return `${minutes} minutes`;
  const hours = minutes / 60;
  return hours === 1 ? "1 hour" : `${Number(hours.toFixed(2))} hours`;
}
